module.exports = __webpack_public_path__ + "static/media/Huis-3-3.96fb63be.jpg";